namespace TabAurous.Inventory {
    export interface SetItemsForm {
        SetId: Serenity.IntegerEditor;
        StockId: Serenity.IntegerEditor;
        ProductId: Serenity.IntegerEditor;
        Line_No: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
    }

    export class SetItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.SetItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SetItemsForm.init)  {
                SetItemsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(SetItemsForm, [
                    'SetId', w0,
                    'StockId', w0,
                    'ProductId', w0,
                    'Line_No', w1,
                    'SKU', w1,
                    'AttributeId', w1
                ]);
            }
        }
    }
}
